<template>
  <v-col class="pa-2 quotes">
    <v-row justify="space-between" class="pa-2 quotes-header">
      <g-button
        :label="searchToggleLabel"
        :icon="showSearch ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
        @onclick="toggleSearch"
      />

      <d-header label="Quotes" />

      <add-button @click="createNew" />
    </v-row>

    <QuoteSearch
      v-show="showSearch"
      ref="quoteSearch"
      @search="updateQuery"
      @layout="recalcHeight"
    />

    <QuoteTable :query="dbQuery" class="mx-2 table" ref="editDBwrapper" :height="dbHeight" />
  </v-col>
</template>

<script>
import { QuoteTable, QuoteSearch } from "@/modules/quotes";
export default {
  components: {
    QuoteTable,
    QuoteSearch,
  },
  data() {
    return {
      showSearch: true,
      dbQuery: {},
      dbHeight: "0px",
      activeFilterCount: 0,
    };
  },
  computed: {
    searchToggleLabel() {
      if (this.showSearch) return "hide search";
      if (this.activeFilterCount > 0) return `show search (${this.activeFilterCount})`;
      return "show search";
    },
  },
  methods: {
    createNew() {
      this.$router.push({
        name: "quotes_new",
      });
    },
    updateQuery(query) {
      this.dbQuery = { ...query };
      this.activeFilterCount = this.countFilters(query);
      this.recalcHeight();
    },
    countFilters(query) {
      if (!query || typeof query !== "object") return 0;
      let count = 0;
      if (Array.isArray(query.keywords)) count += query.keywords.length;
      Object.keys(query).forEach((key) => {
        if (key === "keywords") return;
        if (query[key] !== null && query[key] !== undefined && query[key] !== "") count += 1;
      });
      return count;
    },
    toggleSearch() {
      this.showSearch = !this.showSearch;
      this.recalcHeight();
    },
    recalcHeight() {
      this.$nextTick(() => {
        const root = this.$el;
        const tableEl = this.$refs.editDBwrapper && this.$refs.editDBwrapper.$el;
        if (!root || !tableEl) return;

        const headerEl = root.querySelector(".quotes-header");
        const searchEl = this.$refs.quoteSearch && this.$refs.quoteSearch.$el;
        const headerHeight = headerEl ? headerEl.offsetHeight : 50;
        const searchHeight = this.showSearch && searchEl ? searchEl.offsetHeight + 8 : 0;
        const nextHeight = Math.max(root.clientHeight - headerHeight - searchHeight - 8, 180);
        this.dbHeight = `${nextHeight}px`;
      });
    },
  },
  mounted() {
    this.recalcHeight();
    window.addEventListener("resize", this.recalcHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcHeight);
  },
};
</script>

<style lang="scss">
.quotes {
  height: 100%;
  display: flex;
  flex-direction: column;

  .quotes-header {
    max-height: 50px;
  }

  .quotes-list {
    max-height: 400px;
    overflow: auto;

    &.longlist {
      max-height: 500px;
    }
  }

  .table {
    flex: 1;
    min-height: 0;
  }
}

.db-card:hover {
  cursor: pointer;
}
</style>
